import React, { Fragment, useEffect } from "react";
import styled from "styled-components";

import PaymentAreaWrapper from "../../components/organisms/containers/PaymentAreaWraper";
import UserAssets from "../../components/organisms/user/assets/UserAssets";
import UserCoinsPanel from "../../components/organisms/user/coins/mobile/UserCoinsPanel";
import Slider from "../../components/organisms/slider/Slider";
import DesktopUserCoins from "../../components/organisms/user/coins/desktop/DesktopUserCoins";
import DesktopTransactionsHistory from "../../components/organisms/user/transaction/desktop/DesktopTransactionsHistory";
import EasyTradeWidget from "../Trade/EasyTrade/EasyTradeWidget/EasyTradeWidget";

import DashboardCoinsPanel from "../../components/organisms/coin/DashboardCoinsPanel";
import { useSelector } from "react-redux";
import KycDashboardData from "../../components/organisms/user/dashboardKycData/KycDashboardData";
import DashboardInviteFriend from "../../components/organisms/user/inviteFriendsDashboard/DashboardInviteFriend";
import { RootStore } from "../../store/Store";
import usePageWidth from "../../components/custom-hook/UsePageWidth";
import { NOTIFICATION_REGISTER_TOKEN } from "../../api-calls";
import Map from "../../components/molecules/Map/Map";
import TerminalsMap from "../../components/organisms/TerminalsMap/TerminalsMap";
const MainArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 61.44%;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const OrderArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 32%;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  //height: 80vh;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const DashboardTest: React.FC = () => {
  const width = usePageWidth();
  const UserState = useSelector((state: RootStore) => state.user);
  useEffect(() => {
    // sendNajvaToken();
  }, []);

  // const sendNajvaToken = () => {
  //   if (localStorage.getItem("najva-token")) {
  //     NOTIFICATION_REGISTER_TOKEN().then((res) => {
  //       localStorage.removeItem("najva-token");
  //     });
  //   } else {
  //     return;
  //   }
  // };
  return (
    <Fragment>
      <MainArea>
        <TerminalsMap
          onClickMarker={(id, location) =>
            console.log("id", id, "location", location)
          }
          zoom={15}
        />
      </MainArea>
    </Fragment>
  );
};

export default DashboardTest;
